export function calculateSolution(ac1, ac2, intersection) {
    const v1 = ac1.speed / 60;
    const v2 = ac2.speed / 60;
    const v1x = v1 * Math.sin(ac1.headingRad);
    const v1y = -v1 * Math.cos(ac1.headingRad);
    const v2x = v2 * Math.sin(ac2.headingRad);
    const v2y = -v2 * Math.cos(ac2.headingRad);
    const r0x = ac1.x - ac2.x;
    const r0y = ac1.y - ac2.y;
    const vrx = v1x - v2x;
    const vry = v1y - v2y;
    const vr_dot_r0 = vrx * r0x + vry * r0y;
    const vr_sq = vrx * vrx + vry * vry;

    if (vr_sq === 0) {
        return {
            minDistance: Math.sqrt(r0x * r0x + r0y * r0y),
            timeToCPA: Infinity,
            firstToCross: ac1.callsign,
        };
    }

    const t_cpa = -vr_dot_r0 / vr_sq;
    const cpa_p1x = ac1.x + v1x * t_cpa;
    const cpa_p1y = ac1.y + v1y * t_cpa;
    const cpa_p2x = ac2.x + v2x * t_cpa;
    const cpa_p2y = ac2.y + v2y * t_cpa;
    const minDistance = Math.sqrt(
        Math.pow(cpa_p1x - cpa_p2x, 2) + Math.pow(cpa_p1y - cpa_p2y, 2),
    );

    const distToIntersection1 = Math.sqrt(
        Math.pow(intersection.x - ac1.x, 2) + Math.pow(intersection.y - ac1.y, 2),
    );
    const timeToIntersection1 = distToIntersection1 / v1;
    const distToIntersection2 = Math.sqrt(
        Math.pow(intersection.x - ac2.x, 2) + Math.pow(intersection.y - ac2.y, 2),
    );
    const timeToIntersection2 = distToIntersection2 / v2;
    const firstToCross =
        timeToIntersection1 < timeToIntersection2 ? ac1.callsign : ac2.callsign;

    return { minDistance, timeToCPA: t_cpa, firstToCross };
}
